import { IconProps } from '../icon';

export function DevisIcon(props: IconProps) {
  return (
    <svg
      width="75"
      height="87"
      viewBox="0 0 75 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_447_3178)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 11.5C6 9.51088 6.79018 7.60322 8.1967 6.1967C9.60322 4.79018 11.5109 4 13.5 4H54.535L71 20.465V71.5C71 73.4891 70.2098 75.3968 68.8033 76.8033C67.3968 78.2098 65.4891 79 63.5 79H13.5C11.5109 79 9.60322 78.2098 8.1967 76.8033C6.79018 75.3968 6 73.4891 6 71.5V11.5ZM21 24H36V29H21V24ZM56 39H21V44H56V39ZM56 54H41V59H56V54Z"
          fill="white"
        />
      </g>
      <path
        d="M15 18H13V20V25V27H15H30H32V25V20V18H30H15ZM52 35V33H50H15H13V35V40V42H15H50H52V40V35ZM52 50V48H50H35H33V50V55V57H35H50H52V55V50ZM2 7.5C2 6.04131 2.57946 4.64236 3.61091 3.61091C4.64236 2.57946 6.04131 2 7.5 2H47.7066L63 17.2934V67.5C63 68.9587 62.4205 70.3576 61.3891 71.3891C60.3576 72.4205 58.9587 73 57.5 73H7.5C6.04131 73 4.64236 72.4205 3.61091 71.3891C2.57946 70.3576 2 68.9587 2 67.5V7.5Z"
        stroke="#2A2A2A"
        strokeWidth="4"
      />
      <defs>
        <filter
          id="filter0_d_447_3178"
          x="2"
          y="4"
          width="73"
          height="83"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_447_3178"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_447_3178"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default DevisIcon;
